export const ibrApproval = {
  label: "IBR Approved Firm - Class I",
  shortLabel: "IBR Class I",
  scope: "Boiler and steam pipeline erection and repair works",
  pressureClass: "Class I category up to 125 kg/cm2 (as per approval scope)",
  regulationReference:
    "Indian Boiler Regulations (IBR), 1950 - Regulation 392 category recognition",
  verificationNote:
    "Certificate number and validity details are shared during pre-qualification, tendering, and client audits.",
} as const

export const thermaxAssociation = {
  label: "Thermax Channel Associate",
  summary: "Authorized Channel Associate and Project Franchisee for Thermax Limited",
} as const
